/**
 *   dialog option
 *   替换人员 -- 提示
 */
import {applySettleDicData} from '@/const/crud/settlement/product'
import {toYYYYmmdd} from '@/util/date'
import {getInsureTypesString} from '@/util/insureTypesUtils'
import {getStore} from '@/util/store'

export const optionRepeatHint = {
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	align: 'center',
	menu: false,
	header: false,
	column: [
		{
			label: '姓名',
			prop: 'empName',
			width: 120,
		},
		{
			label: '身份证',
			prop: 'empIdNo',
		},
		{
			label: '被保企业/个人',
			prop: 'unitName',
		},
		{
			label: '保障中保单号',
			prop: 'policyNo',
		},
		{
			label: '保险止期',
			prop: 'expiryDate',
			formatter: ({expiryDate}) => {
				if (!expiryDate) {
					return '未知'
				}
				if (expiryDate.indexOf('-') !== -1 || expiryDate.indexOf('/') !== -1) {
					return expiryDate.indexOf(':') === -1 ? `${expiryDate} 23:59:59` : expiryDate
				}
				return `${toYYYYmmdd(expiryDate)} 23:59:59`
			},
		},
	],
}

export const fontApplyCommitOptionDialog = {
	card: true,
	stripe: true,
	border: true,
	align: 'center',
	addBtn: false,
	menu: false,
	gutter: 40,
	excelBtn: true,
	delBtn: false,
	editBtn: false,
	header: false,
	maxHeight: 450,
	column: [
		{
			label: '保单号',
			prop: 'policyNo',
			width: 200,
		},
		{
			label: '批单号',
			prop: 'endorseNo',
			width: 200,
			hide: false,
		},
		{
			label: '保费金额',
			prop: 'payMoney',
			width: 100,
		},
		{
			label: '基础费用率',
			prop: 'basicFeeRate',
		},
		{
			label: '基础费用(元)',
			prop: 'basicFee',
		},
		{
			label: '附加费用率',
			prop: 'additionalFeeRate',
		},
		{
			label: '附加费用(元)',
			prop: 'additionalFee',
		},
		{
			label: '预计结算费用(元)',
			prop: 'allFeePre',
		},
	],
}

export const fontApplyAwardCommitOptionDialog = {
	card: true,
	stripe: true,
	border: true,
	align: 'center',
	addBtn: false,
	menu: false,
	gutter: 40,
	excelBtn: true,
	delBtn: false,
	editBtn: false,
	header: false,
	maxHeight: 450,
	column: [
		{
			label: '保费金额(元)',
			prop: 'payMoney',
		},
		{
			label: '活动奖励费用率',
			prop: 'feeRate',
		},
		{
			label: '预计结算费用(元)',
			prop: 'feePre',
		},
	],
}

export const fontApplyBasicOptionDialog = {
	card: true,
	stripe: true,
	border: true,
	align: 'center',
	addBtn: false,
	menu: false,
	gutter: 40,
	excelBtn: true,
	delBtn: false,
	editBtn: false,
	header: false,
	maxHeight: 450,
	column: [
		{
			label: '保单号',
			prop: 'policyNo',
			width: 200,
		},
		{
			label: '批单号',
			prop: 'endorseNo',
			width: 200,
			hide: false,
		},
		{
			label: '保费金额',
			prop: 'payMoney',
			width: 100,
		},
		{
			label: '基础费用率',
			prop: 'basicFeeRate',
		},
		{
			label: '基础费用(元)',
			prop: 'basicFee',
		},
		{
			label: '附加费用率',
			prop: 'additionalFeeRate',
		},
		{
			label: '附加费用(元)',
			prop: 'additionalFee',
		},
		{
			label: '预计结算费用(元)',
			prop: 'allFeePre',
		},
		{
			label: '调整后结算费用(元)',
			prop: 'allFee',
			placeholder: '请输入 结算费用',
			rules: [
				{
					required: true,
					trigger: 'blur',
					message: '请输入结算费用',
				},
				{
					validator: (rule, value, callback) => {
						if (isNaN(value)) {
							callback(new Error('只能输入数字!'))
						}
						callback()
					},
					trigger: 'blur',
				},
			],
			cell: true,
		},
	],
}

export const fontApplyAwardOptionDialog = {
	card: true,
	stripe: true,
	border: true,
	align: 'center',
	addBtn: false,
	menu: false,
	gutter: 40,
	excelBtn: true,
	delBtn: false,
	editBtn: false,
	header: false,
	maxHeight: 450,
	column: [
		{
			label: '奖励规则',
			prop: 'name',
			width: 200,
		},
		{
			label: '险种名称',
			prop: 'insureType',
			dicData: getInsureTypesString(),
			width: 200,
		},
		{
			label: '保费金额',
			prop: 'payMoney',
			width: 100,
		},
		{
			label: '预计结算费用(元)',
			prop: 'allFeePre',
		},
		{
			label: '调整后结算费用(元)',
			prop: 'allFee',
			placeholder: '请输入 结算费用',
			rules: [
				{
					required: true,
					trigger: 'blur',
					message: '请输入结算费用',
				},
				{
					validator: (rule, value, callback) => {
						if (isNaN(value)) {
							callback(new Error('只能输入数字!'))
						}
						callback()
					},
					trigger: 'blur',
				},
			],
			cell: true,
		},
	],
}

export const optionApplyHint = {
	border: true,
	stripe: true,
	align: 'center',
	menu: false,
	header: false,
	column: [
		{
			label: '结算编号',
			prop: 'no',
		},
		{
			label: '申请时间',
			prop: 'createdAt',
			type: 'datetime',
		},
		{
			label: '状态',
			prop: 'status',
			dicData: applySettleDicData,
		},
		{
			label: '结算费用(元)',
			prop: 'fee',
		},
	],
}

export const optionChangeFeeHint = {
	border: true,
	stripe: true,
	align: 'center',
	menu: false,
	header: false,
	gutter: 30,
	submitBtn: false,
	emptyBtn: false,
	column: [
		{
			label: '核算金额',
			prop: 'feePre',
			span: 24,
			placeholder: '',
			rules: [
				{
					required: true,
					trigger: 'blur',
					message: '请输入核算金额',
				},
				{
					validator: (rule, value, callback) => {
						if (isNaN(value)) {
							callback(new Error('只能输入数字!'))
						}
						callback()
					},
					trigger: 'blur',
				},
			],
		},
		{
			label: '备注',
			prop: 'remark',
			type: 'textarea',
			showWordLimit: true,
			maxlength: 200,
			minRows: 3,
			maxRows: 5,
			span: 24,
		},
		{
			label: '退回操作',
			prop: 'isCalc',
			type: 'switch',
			disabled: false,
			value: true,
			span: 24,
			control: (val, form) => {
				return {
					feePre: {
						disabled: !val,
						rules: !val
							? []
							: [
									{
										required: true,
										trigger: 'blur',
										message: '请输入核算金额',
									},
									{
										validator: (rule, value, callback) => {
											if (isNaN(value)) {
												callback(new Error('只能输入数字!'))
											}
											callback()
										},
										trigger: 'blur',
									},
							  ],
					},
					remark: {
						disabled: !val,
					},
				}
			},
			dicData: [
				{
					label: '取消扣费',
					value: false,
				},
				{
					label: '扣除佣金',
					value: true,
				},
			],
		},
	],
}

export const payerInfoOptionDialog = {
	menuBtn: false,
	labelWidth: 180,
	labelPosition: 'left',
	column: [
		{
			label: '付款人姓名',
			prop: 'payer',
			span: 24,
			rules: [
				{
					required: true,
					message: '请输入付款人姓名',
					trigger: 'blur',
				},
			],
		},
		{
			label: '付款人账号',
			prop: 'payAccount',
			span: 24,
			rules: [
				{
					required: true,
					message: '请输入付款人账号',
					trigger: 'blur',
				},
			],
		},
		{
			label: '代付款原因',
			prop: 'payFor',
			span: 24,
			rules: [
				{
					required: true,
					message: '请输入代付款原因',
					trigger: 'blur',
				},
			],
		},
		{
			label: '付款人与投保企业关系',
			prop: 'payerWithEnterprise',
			span: 24,
			rules: [
				{
					required: true,
					message: '请输入付款人与投保企业关系',
					trigger: 'blur',
				},
			],
		},
	],
}

export const cardOptionDialog = {
	menuBtn: false,
	column: [
		{
			label: '',
			prop: 'cardImgUrl',
			type: 'upload',
			dragFile: true,
			action: '/dist/distInsure/uploadIdOcr',
			span: 24,
			limit: 10,
			tip: '只能上传jpg/png文件，且不超过6M',
			multiple: true,
			accept: 'image/jpeg,image/png',
			fileSize: 40 * 1024,
			data: {
				side: 'face',
				idName: '',
				batchld: '0',
			},
			propsHttp: {
				res: 'data',
				fileName: 'files',
			},
		},
	],
}

export const couponPolicyListOption = {
	card: true,
	border: true,
	stripe: true,
	align: 'center',
	header: false,
	menu: false,
	highlightCurrentRow: true,
	rowKey: 'policyNo',
	column: [
		{
			label: '保单号',
			prop: 'policyNo',
			span: 12,
			// search: true,
			width: 280,
		},
		{
			label: '被保企业/个人',
			prop: 'insured',
			span: 12,
			// search: true,
		},
		{
			label: '产品名称',
			prop: 'insureTypes',
			type: 'select',
			dicData: getStore({name: 'insureTypes'}),
			props: {
				label: 'name',
				value: 'type',
			},
			hide: true,
			// search: true,
		},
		{
			label: '保障人员',
			prop: 'empInfo',
			hide: true,
			// search: true,
		},
		{
			label: '产品名称',
			prop: 'productName',
			span: 12,
		},
		{
			label: '总保费(元)',
			prop: 'totalMoney',
			slot: true,
			span: 12,
			width: 100,
			formatter: ({totalMoney = 0}) => totalMoney / 100,
		},
		{
			label: '操作人',
			prop: 'distAccountName',
			span: 12,
			search: false,
			width: 100,
		},
		{
			label: '保险起期',
			prop: 'startDate',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			span: 12,
		},
		{
			label: '保险止期',
			prop: 'endDate',
			type: 'datetime',
			format: 'yyyy-MM-dd',
			valueFormat: 'yyyy-MM-dd',
			formatter: ({endDate}) => `${endDate} 23:59:59`,
			span: 12,
		},
		{
			//100:待核保；101：核保中；102:核保拒绝
			label: '状态',
			prop: 'status',
			width: 100,
			dicData: [
				{
					label: '退保',
					value: 0,
				},
				{
					label: '待支付',
					value: 1,
				},
				{
					label: '处理中',
					value: 2,
				},
				{
					label: '保障中',
					value: 3,
				},
				{
					label: '待起保',
					value: 3.5,
				},
				{
					label: '已取消',
					value: 4,
				},
				{
					label: '已到期',
					value: 5,
				},
				{
					label: '待核保',
					value: 100,
				},
				{
					label: '核保中',
					value: 101,
				},
				{
					label: '核保拒绝',
					value: 102,
				},
			],
		},
	],
}

export const optionCouponChannels = {
	card: true,
	border: true,
	stripe: true,
	align: 'center',
	header: false,
	index: true,
	indexLabel: '序号',
	menu: false,
	rowKey: 'id',
	searchBtn: false,
	emptyBtn: false,
	column: [
		{
			label: '渠道名称',
			prop: 'name',
			search: true,
			searchSpan: 10,
		},
		{
			label: '手机号',
			prop: 'loginMobile',
		},
		{
			label: '数量（张）',
			prop: 'count',
		},
	],
}

export const optionCouponChoiceChannels = {
	card: true,
	border: true,
	stripe: true,
	align: 'center',
	header: false,
	index: true,
	indexLabel: '序号',
	menu: false,
	rowKey: 'id',
	searchBtn: false,
	emptyBtn: false,
	selection: true,
	reserveSelection: true,
	column: [
		{
			label: '渠道名称',
			prop: 'name',
			search: true,
			searchSpan: 10,
		},
		{
			label: '手机号',
			prop: 'loginMobile',
		},
		{
			label: '数量（张）',
			prop: 'count',
			cell: true,
		},
	],
}

export const excelOptionDialog = {
	menuBtn: false,
	column: [
		{
			label: '',
			prop: 'excelFile',
			type: 'upload',
			dragFile: true,
			action: '',
			span: 24,
			limit: 1,
			tip: '只能上传excel文件，且不超过4M',
			multiple: true,
			accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			fileSize: 4 * 1024,
			data: {},
			propsHttp: {
				res: 'data',
				// fileName: 'files',
			},
		},
	],
}

export const settleAlertsOptionDialog = {
	card: true,
	border: true,
	stripe: true,
	align: 'center',
	header: false,
	menu: false,
	rowKey: 'idNo',
	column: [
		{
			label: '结算人姓名',
			prop: 'userName',
		},
		{
			label: '身份证',
			prop: 'idNo',
		},
		{
			label: '当期可结算费用（元）',
			prop: 'fee',
			formatter: ({fee = 0}) => (fee ? (fee / 100).toFixed(2) : '--'),
		},
		{
			label: '备注',
			prop: 'statusDesc',
		},
	],
}
